var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.body)?_c('PageBody',{attrs:{"body":_vm.body,"prev":_vm.prev,"next":_vm.next}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }